const REST_API_BASE_URL = process.env.REACT_APP_REST_API_BASE_URL;
const SYSTEM_REST_API_BASE_URL = process.env.REACT_APP_SYSTEM_REST_API_BASE_URL;
const ADMIN_REST_API_BASE_URL = process.env.REACT_APP_ADMIN_REST_API_BASE_URL;
const MANAGER_REST_API_BASE_URL =
  process.env.REACT_APP_MANAGER_REST_API_BASE_URL;
const USER_REST_API_BASE_URL = process.env.REACT_APP_USER_REST_API_BASE_URL;
const USERCONTENT_REST_API_BASE_URL =
  process.env.REACT_APP_USERCONTENT_REST_API_BASE_URL;

export {
  REST_API_BASE_URL,
  SYSTEM_REST_API_BASE_URL,
  ADMIN_REST_API_BASE_URL,
  MANAGER_REST_API_BASE_URL,
  USER_REST_API_BASE_URL,
  USERCONTENT_REST_API_BASE_URL,
};
